import { IUserInfo } from './userInfo';

export interface IGdprConfig {
    disableDeclineAlways?: boolean;
    disableDefaultDecline?: boolean;
    disableAgreeFlush?: boolean;
}

export interface IPageData {
    Lang: string;
    SYSTEM: string;
    siteHost: string;
    userInfo: IUserInfo;
    stepLength?: number;
    payChannel?: string[];
    gdprConfig?: IGdprConfig;
    // [propName: string]: any;
}

export enum PlatformPermission {
    umu = 1,
    use = 2,
    umuAndUse = 3
}
